/* ja-product.js
   Static JS lifted out of inline <script> tags in templates/product.json
   custom-liquid blocks. Loaded once with defer. Each moved script keeps its
   original logic and is wrapped so it runs only once the DOM is ready. */

/* --- from custom_liquid_Dqga4X (Get a Quote / BUY NOW) --- */
(function () {
  function init() {
    var buyNowLink = document.querySelector('.ja-quote-buy-now');
    if (!buyNowLink) return;

    function getAddToCartTarget() {
      return (
        document.querySelector('.product-info__add-to-cart.flex') ||
        document.querySelector('.product-info__add-button') ||
        document.querySelector('product-form button[name="add"]') ||
        document.querySelector('button[name="add"]') ||
        document.getElementById('product-info')
      );
    }

    buyNowLink.addEventListener(
      'click',
      function (e) {
        var target = getAddToCartTarget();
        if (!target || !target.scrollIntoView) return;

        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });

        try {
          var focusTarget = target.matches('button, a, input, select, textarea') ? target : target.querySelector('button, a, input, select, textarea');
          if (focusTarget) focusTarget.focus({ preventScroll: true });
        } catch (err) {}
      },
      { passive: false }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
